// extracted by mini-css-extract-plugin
export default {"container":"NIBranding_container__sTMTj","img":"NIBranding_img__mibFL"};